import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type CheckmarkCircleIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const CheckmarkCircleIcon: React.FC<CheckmarkCircleIconProps> = ({
  title = 'CheckmarkCircle',
  viewBox = '0 0 16 16',
  ...props
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <g fillRule="evenodd">
      <path d="M0 0h16v16H0z" fill="none" />
      <path d="M8 .444a7.556 7.556 0 110 15.112A7.556 7.556 0 018 .444zm2.975 4.81l-.025.022-4.47 4.471L5.151 8.42a.445.445 0 00-.605-.023l-.024.023a.443.443 0 00-.022.604l.022.024 1.957 1.957 5.1-5.1a.445.445 0 00-.604-.651z" />
    </g>
  </CreateIconComponent>
);

export default CheckmarkCircleIcon;
